const currentYear = new Date()?.getFullYear();
const Footer = () => {
  return (
    <footer className="py-8 px-4 border-t border-border/30 mb-[100px]">
      <div className="container mx-auto text-center">
        <p className="text-xl font-bold text-foreground mb-2">
          FireUP Platform
        </p>
        <p className="text-sm text-muted-foreground">
          &copy; {currentYear} FireUP Platform
        </p>
      </div>
    </footer>
  );
};

export default Footer;
